import script from "./BindActivityItemNavs.vue?vue&type=script&setup=true&lang=ts"
export * from "./BindActivityItemNavs.vue?vue&type=script&setup=true&lang=ts"

import "./BindActivityItemNavs.vue?vue&type=style&index=0&id=0f8425bd&lang=scss"

const __exports__ = script;

export default __exports__